import { useCompositeAuth } from 'providers/CompositeAuthProvider'
import { Link } from 'react-router-dom'
import Path, { getMenuForRole } from 'routes/Path'
import MenuLogout from 'images/menu-logout.svg'
import { useMemo } from 'react'

interface Props {
  isMinimized: boolean
}

export default function SidebarMenu(prop: Props) {
  const { logout, getRole } = useCompositeAuth()
  const activePathname = window.location.pathname

  const getLinkStyle = (path: string) => {
    const style = `${
      prop.isMinimized ? 'sidebar-menu-item-minimized' : 'sidebar-menu-item'
    } items-center flex`
    let isSelected = activePathname === path
    // for all quizzes path
    if (path === Path.quizzes.path) {
      isSelected = activePathname.indexOf(Path.quizzes.path) !== -1
    }
    // for all architectures path
    else if (path === Path.architectures.path) {
      isSelected = activePathname.indexOf(Path.architectures.path) !== -1
    }

    let bg = ''
    if (isSelected) {
      bg = prop.isMinimized
        ? 'sidebar-menu-selected-bg-min'
        : 'sidebar-menu-selected-bg'
    }
    return `${style} ${bg}`
  }

  const menuByRole = useMemo(() => {
    const role = getRole()
    return getMenuForRole(role)
  }, [getRole])

  return (
    <div className="sidebar-gradient-bg side-menu h-max">
      <div className="flex min-h-screen w-full flex-col items-center justify-between">
        <div className="sidebar-menu-scrollbar mb-auto mt-auto flex w-full flex-col items-center pb-8">
          <div>
            {menuByRole.map((item, index) => (
              <Link
                data-testid={`link-${item.title}`}
                key={index}
                className={getLinkStyle(item.path)}
                to={item.path}
              >
                {prop.isMinimized && (
                  <div className="ml-[36px] flex justify-center">
                    <img src={item.icon} alt="icon" width={'80%'} />
                  </div>
                )}
                {!prop.isMinimized && (
                  <div className="ml-[34px] w-[140px] text-left">
                    <span className="mentem-button-sidebar text-[#121419]">
                      {item.title}
                    </span>
                  </div>
                )}
              </Link>
            ))}
          </div>
          <div
            style={{
              bottom: 130,
              position: 'absolute',
            }}
          >
            <button
              data-testid="btn-logout"
              className="btn-logout bg-[#FFFFFF] px-4 py-[9px] hover:bg-[#d9d9d9]"
              style={{
                fontFamily: 'Roboto Mono',
                fontSize: 14,
                transition: 'background-color 0.3s linear',
              }}
              onClick={() =>
                logout({
                  logoutParams: { returnTo: window.location.origin },
                })
              }
            >
              {prop.isMinimized && (
                <div className="flex justify-center px-[2px] py-[4px]">
                  <img src={MenuLogout} alt="menu-logout" />
                </div>
              )}
              {!prop.isMinimized && (
                <span
                  className="mentem-button-sidebar"
                  style={{ fontWeight: 500 }}
                >
                  Log out
                </span>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
